import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { Authenticated, Unauthenticated, AuthLoading } from "convex/react";
import { useAuthActions } from "@convex-dev/auth/react";
import { SignIn } from "./SignIn";
import { FleetView } from "./screens/FleetView";
import { Releases } from "./screens/Releases";
import { Detections } from "./screens/Detections";
import { Comparison } from "./screens/Comparison";

// Top-level app: auth gate + operator-cockpit shell. Everything behind auth is
// rendered only when <Authenticated>; the SignIn screen is the only thing an
// unauthenticated operator can reach.
export default function App() {
  return (
    <>
      <AuthLoading>
        <div className="boot">Loading console…</div>
      </AuthLoading>

      <Unauthenticated>
        <SignIn />
      </Unauthenticated>

      <Authenticated>
        <Cockpit />
      </Authenticated>
    </>
  );
}

function Cockpit() {
  const { signOut } = useAuthActions();
  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand-mark">◆</span>
          <span className="brand-name">KinSafe Fleet</span>
        </div>
        <nav className="nav">
          <NavItem to="/fleet" label="Fleet" hint="devices & health" />
          <NavItem to="/releases" label="Releases" hint="config & rollout" />
          <NavItem
            to="/detections"
            label="Detections"
            hint="review & label"
          />
          <NavItem to="/comparison" label="Comparison" hint="A/B metrics" />
        </nav>
        <div className="sidebar-foot">
          <span className="lane-pill">tenant-zero operator</span>
          <button className="btn btn-ghost" onClick={() => void signOut()}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="content">
        <Routes>
          <Route path="/" element={<Navigate to="/fleet" replace />} />
          <Route path="/fleet" element={<FleetView />} />
          <Route path="/releases" element={<Releases />} />
          <Route path="/detections" element={<Detections />} />
          <Route path="/comparison" element={<Comparison />} />
          <Route path="*" element={<Navigate to="/fleet" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function NavItem({
  to,
  label,
  hint,
}: {
  to: string;
  label: string;
  hint: string;
}) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
    >
      <span className="nav-label">{label}</span>
      <span className="nav-hint">{hint}</span>
    </NavLink>
  );
}
